var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.src
    ? _c(
        "section",
        { class: _vm.bannerClass },
        [
          _c("picture", { staticClass: "game-banner__picture" }, [
            _vm.resolvedPhoneBgImage
              ? _c("source", {
                  attrs: {
                    media: "(max-width: 767px)",
                    srcset: _vm.resolvedPhoneBgImage,
                  },
                })
              : _vm._e(),
            _c("img", {
              staticClass: "game-banner__image",
              attrs: { src: _vm.src, alt: _vm.alt },
            }),
          ]),
          _vm.showMobileWinnerMarquee
            ? _c("div", { staticClass: "game-banner__mobile-winners" }, [
                _c("div", { class: _vm.winnerClass }, [
                  _vm.resolvedWinnerTitle
                    ? _c("div", { class: _vm.winnerTitleClass }, [
                        _vm._v(_vm._s(_vm.resolvedWinnerTitle)),
                      ])
                    : _vm._e(),
                  _vm.latestPrizeText
                    ? _c("div", { staticClass: "game-banner__winner-latest" }, [
                        _vm._v(_vm._s(_vm.latestPrizeText)),
                      ])
                    : _vm._e(),
                  _vm.winnerMarqueeItems.length
                    ? _c(
                        "div",
                        { staticClass: "game-banner__winner-marquee" },
                        [
                          _c(
                            "div",
                            {
                              key: `mobile-winners-${_vm.winnerMarqueeVersion}`,
                              staticClass: "game-banner__winner-track",
                            },
                            _vm._l(
                              _vm.winnerMarqueeLoopItems,
                              function (winner, index) {
                                return _c(
                                  "span",
                                  {
                                    key: index,
                                    staticClass: "game-banner__winner-item",
                                  },
                                  [_vm._v(_vm._s(winner))]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm.hasDrawTrigger
            ? _c(
                "button",
                {
                  staticClass: "game-banner__draw",
                  attrs: {
                    type: "button",
                    disabled: _vm.buttonDisabled,
                    "aria-label": _vm.buttonAriaLabel,
                  },
                  on: {
                    click: function ($event) {
                      _vm.showOrderWindow = true
                    },
                  },
                },
                [
                  _vm._t("button", function () {
                    return [
                      _vm.resolvedDrawImage
                        ? _c("img", {
                            staticClass: "game-banner__draw-image",
                            attrs: { src: _vm.resolvedDrawImage, alt: "" },
                          })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm.showActivityLayer
            ? _c("div", { staticClass: "game-banner__activity" }, [
                _vm.showFunctionalCountdown
                  ? _c(
                      "div",
                      { staticClass: "game-banner__countdown" },
                      [
                        _vm._t(
                          "countdown",
                          function () {
                            return [
                              _c("div", { class: _vm.countdownArtClass }, [
                                _vm.countdownImage
                                  ? _c("img", {
                                      staticClass:
                                        "game-banner__countdown-image",
                                      attrs: {
                                        src: _vm.countdownImage,
                                        alt: "",
                                      },
                                    })
                                  : _c(
                                      "span",
                                      { class: _vm.countdownLabelClass },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.resolvedCountdownLabel)
                                        ),
                                      ]
                                    ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "game-banner__countdown-values",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.displayTime.hours)),
                                    ]),
                                    _c("i", [_vm._v(":")]),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.displayTime.minutes)),
                                    ]),
                                    _c("i", [_vm._v(":")]),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.displayTime.seconds)),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          },
                          { time: _vm.displayTime }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.showFunctionalRule
                  ? _c(
                      "button",
                      {
                        staticClass: "game-banner__rule",
                        attrs: { type: "button", disabled: _vm.ruleDisabled },
                        on: {
                          click: function ($event) {
                            _vm.showRuleModal = true
                          },
                        },
                      },
                      [
                        _vm._t("rule", function () {
                          return [
                            _c("span", {
                              staticClass: "game-banner__rule-dot",
                            }),
                            _c("span", { class: _vm.ruleTextClass }, [
                              _vm._v(_vm._s(_vm.resolvedRuleText)),
                            ]),
                          ]
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.showWinnerList
                  ? _c("div", { staticClass: "game-banner__winner-wrap" }, [
                      _vm.showWinnerImage
                        ? _c(
                            "div",
                            { staticClass: "game-banner__winner-image-box" },
                            [
                              _vm._t("winner-image", function () {
                                return [
                                  _c("img", {
                                    staticClass: "game-banner__winner-image",
                                    attrs: {
                                      src: _vm.resolvedWinnerImage,
                                      alt: "",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "game-banner__winner-image-table",
                                      style: _vm.winnerImageTableStyle,
                                    },
                                    _vm._l(
                                      _vm.winnerImageTableItems,
                                      function (winner, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            class: [
                                              "game-banner__winner-image-cell",
                                              {
                                                "game-banner__winner-image-cell--progress":
                                                  winner.type === "progress",
                                              },
                                            ],
                                          },
                                          [
                                            winner.type === "progress"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "game-banner__winner-progress-image-row",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "game-banner__winner-progress-stack",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "game-banner__winner-progress-bar-wrap",
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticClass:
                                                                "game-banner__winner-progress-image",
                                                              attrs: {
                                                                src: winner.progressImage,
                                                                alt: "",
                                                              },
                                                            }),
                                                            winner.progressGridImage &&
                                                            winner
                                                              .progressGridItems
                                                              .length
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "game-banner__winner-progress-grid-list",
                                                                  },
                                                                  _vm._l(
                                                                    winner.progressGridItems,
                                                                    function (
                                                                      _,
                                                                      gridIndex
                                                                    ) {
                                                                      return _c(
                                                                        "img",
                                                                        {
                                                                          key: gridIndex,
                                                                          staticClass:
                                                                            "game-banner__winner-progress-grid-image",
                                                                          attrs:
                                                                            {
                                                                              src: winner.progressGridImage,
                                                                              alt: "",
                                                                            },
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                )
                                                              : _vm._e(),
                                                            winner.progressGridCount >=
                                                              10 &&
                                                            _vm.resolvedWinnerProgressStickerImage
                                                              ? _c("img", {
                                                                  class:
                                                                    _vm.winnerProgressStickerClass,
                                                                  attrs: {
                                                                    src: _vm.resolvedWinnerProgressStickerImage,
                                                                    alt: "",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        winner.progressLeftImage ||
                                                        winner.progressRightImage
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "game-banner__winner-progress-label-images",
                                                              },
                                                              [
                                                                winner.progressLeftImage
                                                                  ? _c("img", {
                                                                      attrs: {
                                                                        src: winner.progressLeftImage,
                                                                        alt: "",
                                                                      },
                                                                    })
                                                                  : _vm._e(),
                                                                winner.progressRightImage
                                                                  ? _c("img", {
                                                                      attrs: {
                                                                        src: winner.progressRightImage,
                                                                        alt: "",
                                                                      },
                                                                    })
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : [
                                                  winner.image
                                                    ? _c("img", {
                                                        staticClass:
                                                          "game-banner__winner-image-cell-icon",
                                                        attrs: {
                                                          src: winner.image,
                                                          alt: "",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "game-banner__winner-image-cell-content",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class:
                                                            _vm.winnerImageCellTitleClass,
                                                        },
                                                        [
                                                          winner.titleParts &&
                                                          winner.titleParts
                                                            .length
                                                            ? _vm._l(
                                                                winner.titleParts,
                                                                function (
                                                                  part,
                                                                  partIndex
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    {
                                                                      key: partIndex,
                                                                      class: {
                                                                        "game-banner__winner-image-cell-title-highlight":
                                                                          part.highlight,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            part.text
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            : [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    winner.title
                                                                  )
                                                                ),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      winner.subtitle
                                                        ? _c(
                                                            "div",
                                                            {
                                                              class:
                                                                _vm.winnerImageCellSubtitleClass,
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    winner.subtitle
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ],
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { class: _vm.winnerClass },
                        [
                          _vm._t("winner", function () {
                            return [
                              _vm.resolvedWinnerTitle
                                ? _c("div", { class: _vm.winnerTitleClass }, [
                                    _vm._v(_vm._s(_vm.resolvedWinnerTitle)),
                                  ])
                                : _vm._e(),
                              _vm.latestPrizeText
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "game-banner__winner-latest",
                                    },
                                    [_vm._v(_vm._s(_vm.latestPrizeText))]
                                  )
                                : _vm._e(),
                              _vm.winnerMarqueeItems.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "game-banner__winner-marquee",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "game-banner__winner-track",
                                        },
                                        _vm._l(
                                          _vm.winnerMarqueeLoopItems,
                                          function (winner, index) {
                                            return _c(
                                              "span",
                                              {
                                                key: index,
                                                staticClass:
                                                  "game-banner__winner-item",
                                              },
                                              [_vm._v(_vm._s(winner))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.hasLogin && _vm.dynamicComponent && _vm.showOrderWindow
            ? _c(_vm.dynamicComponent, {
                tag: "component",
                attrs: { goods: _vm.goods, rebate: _vm.rebate },
                on: { close: _vm.closeOrderWindow },
              })
            : _vm._e(),
          _c("transition", { attrs: { name: "gb-rule-fade" } }, [
            _vm.showRuleModal
              ? _c(
                  "div",
                  {
                    staticClass: "gb-rule-overlay",
                    on: {
                      click: function ($event) {
                        if ($event.target !== $event.currentTarget) return null
                        _vm.showRuleModal = false
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "gb-rule-modal" }, [
                      _c("div", { staticClass: "gb-rule-modal__header" }, [
                        _c("div", { staticClass: "gb-rule-modal__title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.gameData &&
                                (_vm.gameData.gameCode === "fzsgkr" ||
                                  _vm.gameData.gameCode === "lycqkr")
                                ? "이벤트 규칙"
                                : "活動規則"
                            )
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "gb-rule-modal__close",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.showRuleModal = false
                              },
                            },
                          },
                          [_vm._v("X")]
                        ),
                      ]),
                      _vm.gameData && _vm.gameData.gameCode === "lycqkr"
                        ? _c("div", { staticClass: "gb-rule-modal__body" }, [
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v("행운 추첨·쿠폰 대상"),
                            ]),
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v(
                                "매일 공식 홈페이지에서 임의 금액을 충전하면, 당일 추첨에 자동 참여됩니다!"
                              ),
                            ]),
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v(
                                "매일 오전 11:00에 당첨자가 발표되며, 행운의 용사님은 최대 [25% 페이백 쿠폰] 1장을 단독으로 획득할 수 있습니다!"
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("1. 참여 자격")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "매일 00:00-23:59 기간 공식 홈페이지에서 임의 금액을 충전한 주공님은 당일 추첨 풀에 자동으로 포함됩니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "계정당 매일 첫 번째 충전 건만 인정되며, 같은 날 추가 충전은 중복 참여로 인정되지 않습니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("2. 추첨 시간")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "매일 오전 10:00에 추첨을 진행하며, 행운의 주공님 1명을 선정합니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "추첨 대상은 전일 00:00-23:59기간 내 조건을 충족한 주공님입니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("3. 추첨 조건 및 보상 안내")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "당일 추첨 풀 참여 인원이 이벤트 기준 최소 인원에 도달하면 [25% 페이백 쿠폰] ×1을 지급합니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "참여 인원이 최소 인원에 도달하지 못하더라도 추첨은 진행되며, 보상은 [10% 페이백 쿠폰] ×1로 조정됩니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "조건 달성 여부와 관계없이 매일 추첨은 반드시 진행되며, 보상은 절대 놓치지 않습니다!"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("4. 이벤트 보상")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "gb-rule-modal__reward" },
                                      [
                                        _vm._v(
                                          "25% 페이백 쿠폰: 기준 인원 달성 시 지급"
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "10% 페이백 쿠폰: 기준 인원 미달성 시 보장 지급"
                                        ),
                                      ]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        "사용 방법: 공식 홈페이지 충전 시 페이백 쿠폰 사용을 선택하면, 해당 비율의 추가 페이백을 받을 수 있습니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v("예시: 25% 쿠폰 사용 기준"),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "₩149000 금괴 상품 충전 시, 기본 149000 금괴는 충전 후 게임 내 즉시 지급되며, 추가 ₩37250 페이백 금괴는 우편으로 지급됩니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "유효 기간: 수령 후 24시간 이내 사용해야 합니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "적용 한도: 최대 ₩1000000 및 이하 충전 상품에만 사용할 수 있습니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("5. 당첨자 확인")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "당첨된 용사님은 공식 홈페이지 로그인 후, [페이백 금괴] 메뉴에서 해당 쿠폰을 확인할 수 있습니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "공식 홈페이지 메인 [행운 추첨] 영역에는 전일 및 최근 당첨 용사님의 캐릭터명이 표시되며, 매일 추첨 후 갱신됩니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("6. 유의사항")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "이벤트 내용은 내부 사정에 따라 변경될 수 있으며, 변경 시 공식 라운지에 공지를 통해 안내됩니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "본 이벤트는 기타 할인, 금괴 혜택과 중복 사용할 수 없습니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "부정 참여 또는 버그 악용이 확인될 경우, 추첨 및 당첨 자격이 취소될 수 있습니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm.gameData && _vm.gameData.gameCode === "fzsgkr"
                        ? _c("div", { staticClass: "gb-rule-modal__body" }, [
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v("행운 추첨·쿠폰 대상"),
                            ]),
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v(
                                "매일 공식 홈페이지에서 임의 금액을 충전하면, 당일 추첨에 자동 참여됩니다!"
                              ),
                            ]),
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v(
                                "매일 오전 11:00에 당첨자가 발표되며, 행운의 주공님은 최대 [50% 페이백 쿠폰] 1장을 단독으로 획득할 수 있습니다!"
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("1. 참여 자격")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "매일 00:00-23:59 기간 공식 홈페이지에서 임의 금액을 충전한 주공님은 당일 추첨 풀에 자동으로 포함됩니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "계정당 매일 첫 번째 충전 건만 인정되며, 같은 날 추가 충전은 중복 참여로 인정되지 않습니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("2. 추첨 시간")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "매일 오전 10:00에 추첨을 진행하며, 행운의 주공님 1명을 선정합니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "추첨 대상은 전일 00:00-23:59기간 내 조건을 충족한 주공님입니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("3. 추첨 조건 및 보상 안내")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "당일 추첨 풀 참여 인원이 이벤트 기준 최소 인원에 도달하면 [50% 페이백 쿠폰] ×1을 지급합니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "참여 인원이 최소 인원에 도달하지 못하더라도 추첨은 진행되며, 보상은 [30% 페이백 쿠폰] ×1로 조정됩니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "조건 달성 여부와 관계없이 매일 추첨은 반드시 진행되며, 보상은 절대 놓치지 않습니다!"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("4. 이벤트 보상")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "gb-rule-modal__reward" },
                                      [
                                        _vm._v(
                                          "50% 페이백 쿠폰: 기준 인원 달성 시 지급"
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "30% 페이백 쿠폰: 기준 인원 미달성 시 보장 지급"
                                        ),
                                      ]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        "사용 방법: 공식 홈페이지 충전 시 페이백 쿠폰 사용을 선택하면, 해당 비율의 추가 페이백을 받을 수 있습니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v("예시: 50% 쿠폰 사용 기준"),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "₩149000 상품 충전 시, 기본 149000 금전쿠폰는 충전 후 게임 내 즉시 지급되며, 추가 ₩74500 페이백 금전쿠폰은 고객센터 문의 후 우편으로 지급됩니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "유효 기간: 수령 후 24시간 이내 사용해야 합니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "적용 한도: 최대 ₩149000 및 이하 충전 상품에만 사용할 수 있습니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("5. 당첨자 확인")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "당첨된 주공님은 공식 홈페이지 로그인 후, [페이백 금전쿠폰] 메뉴에서 해당 쿠폰을 확인할 수 있습니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "공식 홈페이지 메인 [행운 추첨] 영역에는 전일 및 최근 당첨 주공님의 캐릭터명이 표시되며, 매일 추첨 후 갱신됩니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("6. 유의사항")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "이벤트 내용은 내부 사정에 따라 변경될 수 있으며, 변경 시 공식 라운지에 공지를 통해 안내됩니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "본 이벤트는 기타 할인, 금전 쿠폰 혜택과 중복 사용할 수 없습니다."
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "부정 참여 또는 버그 악용이 확인될 경우, 추첨 및 당첨 자격이 취소될 수 있습니다."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _c("div", { staticClass: "gb-rule-modal__body" }, [
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v("鴻運當頭抽大獎"),
                            ]),
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v(
                                "每日於官網完成任意金額儲值，即可自動參加當日抽獎！"
                              ),
                            ]),
                            _c("p", { staticClass: "gb-rule-modal__intro" }, [
                              _vm._v(
                                "每日 上午 10:00 準時開獎，幸運兒最高將獨得【50% 返利券】1 張！"
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("一、參與資格")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "每日 00:00 – 23:59 (UTC+8) 期間，於官網完成任意金額儲值的玩家，將自動進入當日獎池。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "每個帳號每日僅以第一筆儲值計算，同日的後續儲值不重複參加。"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("二、開獎時間")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "每日 上午 10:00 (UTC+8) 開獎，抽出 1 位幸運主公。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "抽獎範圍為前一日 00:00 – 23:59 符合資格的玩家。"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("三、開獎條件與獎勵等級（新機制）")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "當日獎池參與人數達到活動規定的最低人數門檻，開獎送出【50% 返利券】×1。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "當日獎池參與人數未達最低人數門檻，依然開獎，但獎勵調整為【30% 返利券】×1。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "無論是否達標，每日保證開獎，獎勵永不落空！"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("四、活動獎勵")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "gb-rule-modal__reward" },
                                      [
                                        _vm._v(
                                          "50% 返利券（達標時發放）／30% 返利券（未達標時保底發放）"
                                        ),
                                      ]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        "使用方式：在官網儲值時勾選使用返利券，即可獲得對應比例的額外回饋。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "範例（以 50% 券為例）：儲值 $49.99 品項，可獲得原 4,999 代金券（儲值後遊戲內立即發放）+ 2,499 返利代金券（聯繫客服郵件發放）。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "有效期限：領取後 24 小時內須使用完畢。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "適用上限：最高可用於 $49.99 及以下的儲值品項。"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("五、中獎展示")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "中獎玩家登入官網後，前往「返利券」專區即可看到對應返利券。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "官網首頁「鴻運當頭」專區將展示昨日及近期幸運兒（角色名），每日開獎後更新。"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "gb-rule-modal__section" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-title",
                                  },
                                  [_vm._v("六、注意事項")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gb-rule-modal__section-body",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "官方保留活動最終修改與解釋權，任何調整將於官網公告。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "本活動不得與其他優惠碼、折扣或代金券同時使用。"
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "如發現違規或利用漏洞參加者，官方有權取消其抽獎及得獎資格。"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }